import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
    id: 'UA-134202931-1',
    debug: {
        sendHitTask: process.env.NODE_ENV === 'production'
    }
});